import comparators, {
  CONTAINS,
  IS_NOT_SET,
  IS_SET,
  MATCHES_REGEX,
  STARTS_WITH,
  WITHIN_SYMBOL,
  WITHIN,
} from 'utils/comparatorTypes';
import * as fieldTypes from 'utils/fieldTypes';
import moment from 'moment';
import { displayDate, DATE_FORMAT } from 'utils/date';

const { DATE } = fieldTypes;

const COMPARATOR_SYMBOL_OVERRIDES = {
  [CONTAINS]: 'contains',
  [IS_NOT_SET]: 'is not set',
  [IS_SET]: 'is set',
  [MATCHES_REGEX]: 'matches',
  [STARTS_WITH]: 'starts with',
};

const COMPARATOR_DESCRIPTORS = Object.values(comparators).reduce(
  (acc, { name, symbol }) =>
    name === WITHIN && symbol === WITHIN_SYMBOL // this is already taken care of by `LESS_THAN`
      ? acc
      : {
          ...acc,
          [name]: COMPARATOR_SYMBOL_OVERRIDES[name] || symbol,
        },
  {},
);

// type ComparatorType = $Keys<COMPARATOR_DESCRIPTORS>;

/**
 * Returns either a symbol or a readable string for the comparator
 */
export const getComparatorDescriptor = (comparatorType /*: ComparatorType */) /*: string */ =>
  COMPARATOR_DESCRIPTORS[comparatorType];

/**
 * Returns a boolean if number is in milliseconds
 */
export const isMilliseconds = (num) => typeof num === 'number' && num / 1000 >= 1;

/**
 * Returns a readable string for the query value
 */
export const parseQueryValue = (
  value /*: any */,
  fieldType /*: $Values<fieldTypes> */,
  comparatorType /*: ComparatorType */,
) /*: string */ => {
  if ([IS_SET, IS_NOT_SET].includes(comparatorType)) return '';
  if (fieldType !== DATE) return value;

  const intVal = Number(value);
  const momentValue = isMilliseconds(intVal) ? moment(intVal) : moment(value);

  return moment(momentValue).isValid() ? displayDate(momentValue, DATE_FORMAT) : value;
};
